<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <CalendarEvent
            v-for="(calendarEvent, idx) in groupedEvents"
            :key="calendarEvent.date_from + '_' + idx + '_' + calendarEvent.id"
            :calendar-event="calendarEvent"
            @edit-company-event="$emit('edit-company-event', calendarEvent)"
        />
    </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import AccountModule from "../../store/modules/account";
import {$t, $tc} from "@/i18n";

import CalendarEvent from "@/views/Calendar/CalendarEvent.vue";
import {CALENDAR_TYPE} from "@/modules/calendar/calendar";

export default {
    name: "CalendarEvents",
    components: {
        CalendarEvent
    },
    props: {
        events: {
            type: Array,
            required: true
        }
    },
    setup(props, ctx) {
        const { current_account } = AccountModule();

        const groupEventsByType = (
            events,
            filterTypes,
            primaryType,
            nameTranslation,
            groupName,
            showNumberOfEventsAtNumber
        ) => {
            if (!current_account.value.data[groupName]) {
                return events
            }

            const filteredEvents = events.filter(x => filterTypes.includes(x.type))

            if (filteredEvents.length > 1) {
                events = events.filter(x => !filterTypes.includes(x.type))
                let name

                if (filteredEvents.length < showNumberOfEventsAtNumber) {
                    const initials = filteredEvents.map(event => event.initials)

                    const initialsText = initials.join(', ')
                    name = nameTranslation.format(initialsText)
                } else {
                    name = nameTranslation.format(filteredEvents.length)
                }

                events.push({
                    'events': filteredEvents,
                    'type': primaryType,
                    'name': name
                })
            }

            return events
        }

        const groupedEvents = computed(() => {
            let events = props.events.slice()

            events = groupEventsByType(
                events,
                ['member_birthday'],
                'member_birthday',
                $tc('Member birthday | Member birthdays', events.filter(x => x.type === 'member_birthday').length),
                'show_member_birthdays_group',
                5
            )
            events = groupEventsByType(
                events,
                ['contact_birthday'],
                'contact_birthday',
                $tc('Contact birthday | Contact birthdays', events.filter(x => x.type === 'contact_birthday').length),
                'show_contact_birthdays_group',
                1
            )
            events = groupEventsByType(
                events,
                Object.values(CALENDAR_TYPE),
                'away',
                $t('{0} away'),
                'show_vacations_group',
                5
            )

            return events
        });

        return {
            groupedEvents
        };
    }
};
</script>
